import React from 'react';
import { Typography, Divider, Box } from '@mui/material';

interface FormSectionHeaderProps {
    title: string;
}

const FormSectionHeader: React.FC<FormSectionHeaderProps> = ({ title }) => {
    return (
        <Box width="100%" mb={2}>
            <Typography variant="h2">{title}</Typography>
            <Divider sx={{ mt: 1, mb: 4 }} />
        </Box>
    );
};

export default FormSectionHeader;
